import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 11.01L3 11v2h18zM3 16h12v2H3zM21 6H3v2.01L21 8z"
}), 'NotesSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/NotesSharp.js
// module id = 5089
// module chunks = 2